module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_1.1a78b889.png";